// eslint-disable-next-line no-unused-vars
import request from '@/service/http'


export function searchList (data) {
  return request({
    url: '/api/teacher/searchList',
    method: 'post',
    data,
  })
}

export function detail (data) {
  return request({
    url: '/api/teacher/detail',
    method: 'post',
    data,
  })
}

export function saveIntroduce (data) {
  return request({
    url: '/api/teacher/saveIntroduce',
    method: 'post',
    data,
  })
}

export function saveAvatar (data) {
  return request({
    url: '/api/teacher/saveAvatar',
    method: 'post',
    data,
  })
}

export function saveQualificationUrl (data) {
  return request({
    url: '/api/teacher/saveQualificationUrl',
    method: 'post',
    data,
  })
}

export function deleteQualification (data) {
  return request({
    url: '/api/teacher/deleteQualification',
    method: 'post',
    data,
  })
}



